export default __webpack_public_path__ + "static/media/AliciaLovelace.13ce530b.png";